export type LoginHubConsumeTokenAction = (token: string) => Promise<boolean>;
